import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-amber-500 to-orange-600 p-2 rounded-lg">
                <Heart className="w-5 h-5 text-white" fill="white" />
              </div>
              <div>
                <h3 className="font-bold text-white text-sm">David's Harmony House</h3>
                <p className="text-xs text-gray-400">Foundation Inc.</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Transforming lives through faith-based community support and sustainable pathways to restoration.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors duration-300"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors duration-300"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors duration-300"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors duration-300"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-orange-400 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/programs" className="hover:text-orange-400 transition-colors duration-200">
                  Our Programs
                </Link>
              </li>
              <li>
                <Link to="/success-stories" className="hover:text-orange-400 transition-colors duration-200">
                  Success Stories
                </Link>
              </li>
              <li>
                <Link to="/get-help" className="hover:text-orange-400 transition-colors duration-200">
                  Get Help
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="hover:text-orange-400 transition-colors duration-200">
                  Volunteer
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Our Programs</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/programs/veei" className="hover:text-orange-400 transition-colors duration-200">
                  Veterans Empowerment
                </Link>
              </li>
              <li>
                <Link to="/programs/assisted-living" className="hover:text-orange-400 transition-colors duration-200">
                  Assisted Living
                </Link>
              </li>
              <li>
                <Link to="/programs/foster-youth" className="hover:text-orange-400 transition-colors duration-200">
                  Foster Youth Transition
                </Link>
              </li>
              <li>
                <Link to="/programs/reentry" className="hover:text-orange-400 transition-colors duration-200">
                  Reentry Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-orange-400 transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-orange-400 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-gray-700">
              <p className="text-xs text-gray-400">{contactInfo.hours}</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} David's Harmony House Foundation Inc. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="hover:text-orange-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-orange-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
          <p className="text-xs text-gray-500 text-center md:text-left mt-4">
            In partnership with J K Awesome Deeds LLC | A 501(c)(3) Nonprofit Organization
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
